module.exports = __webpack_public_path__ + "img/arrow.7ba4b452.svg";